export default {
    newDesign: true,
    parameters: {
        segment: 54,
        landing_id: "SpQRFC",
    },
    title:
        "Responde 5 preguntas y obtén el curso gratuito para tu hijo/a | Kodland",
    downtimeUrl: "https://www.kodland.org/es",
    startPage: {
        title:
            "Responde 5 preguntas y obtén el curso gratuito para tu hijo/a",
        subtitle:
            "3 lecciones interactivas de programación en Roblox — tu hijo/a aprende creando su propio juego, con un profesor en vivo.",
        image: {
            url: "/welcome/spain_roblox_freecourse_desk.png",
            style: {
                height: "100%",
                "max-height": "100vh",
            },
        },
        imageMobile: {
            url: "/welcome/spain_roblox_freecourse_mob.png",
            style: {
                width: "100%",
            },
        },
        button: "Empezar 🚀",
    },
    stopPage: {
        image: "/welcome/quizV2/no-computer.png",
        title: "¡Gracias por confiar en nuestra plataforma educativa!",
        subtitle:
            "Lamentablemente, las tabletas y los teléfonos no son adecuados para nuestras clases. ¡Esperamos verte en nuestras lecciones en otra ocasión!",
    },
    customStopPages: {
        child: {
            title: "Lamentablemente, solo un padre, madre o tutor puede inscribir a un estudiante en las clases.",
            subtitle:
                "Si quieres continuar, puedes compartir este enlace con tus padres. ¡Esperamos verte pronto en nuestras clases!",
            image: "/welcome/quizV2/child-parent.png",
        },
    },
    quizRotateBySteps: {
        1: {
            question: "Quién está completando este test?",
            answers: [
                "👨‍💻 Soy mamá o papá",
                "👵 Soy otro familiar / tutor",
                {
                    answer: "👦 Soy el hijo/a",
                    stopAnswer: true,
                    customStopPageId: "child",
                },
            ],
        },
        2: {
            question:
                "¿Cómo describirías la relación de tu hijo/a con Roblox?",
            answers: [
                "🕹️ Le encanta jugar, pero me gustaría que también creara.",
                "🌟 Es muy creativo/a y siempre imagina mundos nuevos.",
                "🤔 Pasa mucho tiempo frente a la pantalla y quiero que sea productivo.",
                "🎨 Le gusta personalizar su avatar y el diseño.",
            ],
        },
        3: {
            question: "¿Qué te gustaría que tu hijo/a logre al convertir su hobby en aprendizaje?",
            answers: [
                "🚀 Que aprenda a crear sus propios juegos, no solo a jugar.",
                "💡 Que desarrolle el pensamiento lógico y la programación.",
                "🛡️ Que aprenda a navegar por internet de forma segura.",
                "📈 Que entienda cómo funciona la tecnología por dentro.",
            ],
        },
        4: {
            question: "¿Tienes una computadora de escritorio/portátil donde puedas trabajar?",
            answers: [

                "💻 Sí",
                {
                    answer: "😐 No",
                    stopAnswer: true
                },
            ],
        },
        5: {
            title: "¿Cuántos años tiene tu hijo?",
            type: "age",
            button: "",
        },
        6: {
            typeInfo: "congrats",
            title: "🎉 ¡Todo listo para tu clase gratis!",
            subtitle:
                "En el siguiente paso deja tus datos de contacto y luego elige el día y la hora que mejor te convenga.",
            button: "📅 Agendar clase gratis",
        },
        7: {
            title: "Inscríbete a una clase de prueba gratuita",
            type: "one-page-contacts",
            subtitle:
                "Conversemos, conoce nuestro método y descubre todo lo que tu hijo puede aprender con nosotros.",
            button: "Casi terminamos 🔥",
        },
        8: {
            title: "",
            type: "timeslot",
            subtitle: "",
            button: "",
        },
        9: {
            title: "Revisa estos detalles para completar el registro ✨",
            typeInfo: "pc-laptop",
            subtitle:
                "Ten en cuenta que para la lección necesitaras una PC o laptop en funcionamiento y que deberás acompañar a tu hijo/a durante toda la clase. Recuerda que la misma es individual y personalizada.",
            button: "¿Qué más?",
        },
        10: {
            title: "Chequea tu correo y WhatsApp antes de la clase de prueba📞",
            typeInfo: "whatsapp",
            subtitle:
                "24hs antes estaremos enviándote un recordatorio y 2 horas antes de la clase te pediremos que confirmes tu asistencia. Es muy importante que estemos en contacto para que la clase no se cancele.",
            button: "¿Qué más?",
        },
        11: {
            title: "La clase se realizará en nuestra plataforma 💻",
            typeInfo: "classroom",
            subtitle:
              "Recibirás un enlace y un código único por WhatsApp y correo electrónico. Solo tienes que hacer clic en el enlace, te llevará directamente a la clase. Sin aplicaciones adicionales, sin descargas.",
            button: "Entendido ✅",
        },
    },
};
